// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import AuditLogsSearchTable from './audit-logs-search-table';
import AuditLogGlobalPage from './AuditLogGlobalPage';
import { MrAppMain } from '@ion/components';
import { MrAppLayout } from '@ion/components';

import Header from 'app/components/app-header';
import SideNav from 'app/components/side-nav';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import styles from './index.module.scss';

export default function AuditLogsPage() {
  const { auditLogSharedRetrievalMvpEnabled } = useFeatureEnabled(FEATURE_FLAGS.auditLogSharedRetrievalMvp);

  return (
    <MrAppLayout
      title="Audit Log"
      description="View audit log"
      sideNav={<SideNav />}
      header={<Header icon="auditLog" title="Audit Log" route="audit-log" />}
    >
      <MrAppMain loading={false} className={styles.main}>
        {auditLogSharedRetrievalMvpEnabled ? <AuditLogGlobalPage /> : <AuditLogsSearchTable />}
      </MrAppMain>
    </MrAppLayout>
  );
}
